// hooks/useFollow.ts
import useSWR from 'swr'
import instance from '@/lib/axiosInstance'

type FollowStatus = {
  isFollowing: boolean
  requestPending: boolean
}

// a shared SWR fetcher using your axios instance
const fetcher = <T>(url: string) =>
  instance.get<T>(url).then(res => res.data)

export function useFollowStatus(userId: number) {
  const { data, error, mutate } = useSWR<FollowStatus>(
    `/users/${userId}/follow-status`,
    fetcher
  )

  return {
    status: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export async function follow(userId: number) {
  return instance.post(`/follow/${userId}`)
}

export async function unfollow(userId: number) {
  return instance.delete(`/unfollow/${userId}`)
}

export async function sendRequest(userId: number) {
  return instance.post(`/follow-request/${userId}`)
}

export async function removeRequest(userId: number) {
  return instance.delete(`/follow-request/${userId}`)
}

export async function respondRequest(
  requestId: number,
  action: 'accepted' | 'rejected'
) {
  return instance.patch(`/follow-request/${requestId}`, { action })
}
